// extracted by mini-css-extract-plugin
export var container = "FooterCategoryV2-module--container--6c74c";
export var section = "FooterCategoryV2-module--section--d9f69";